/**
 * Links to the user agreement and the privacy policy.
 *
 * The documents live on airoundme.ru only (landing/terms/, landing/privacy/),
 * the same pages the bot opens. In the browser they open in a new tab, so the
 * login form keeps what was typed; in Telegram through openLink, out of the
 * WebView.
 */
import type { ReactNode } from 'react'
import { usePlatform } from '@/auth/AuthProvider'

export const TERMS_URL = 'https://airoundme.ru/terms/'
export const PRIVACY_URL = 'https://airoundme.ru/privacy/'

export function LegalLink({ href, children }: { href: string; children: ReactNode }) {
  const platform = usePlatform()

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      onClick={(event) => {
        if (platform?.kind === 'telegram') {
          event.preventDefault()
          platform.openExternal(href)
        }
      }}
      className="text-link underline"
    >
      {children}
    </a>
  )
}
